import { render, staticRenderFns } from "./SettingForm.vue?vue&type=template&id=fdd6623a&scoped=true&"
import script from "./SettingForm.vue?vue&type=script&lang=ts&"
export * from "./SettingForm.vue?vue&type=script&lang=ts&"
import style0 from "./SettingForm.vue?vue&type=style&index=0&id=fdd6623a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd6623a",
  null
  
)

export default component.exports